import {
  SendLimitDefinition,
  WhatsAppSenderStatus,
  WhatsAppSendLimit,
} from 'modules/graphql/types';
import { WHATSAPP_SEND_LIMIT_DISPLAY_MAPPING } from 'modules/sendingPlatforms/constants/text';
import { WHATSAPP_SENDER_RESTRICTED_STATUSES } from 'modules/templateEditor/common/constants';
import styled from 'styled-components';
import { ErrorBanner, WarningBanner } from 'ui/banner';
import { spacing } from 'ui/theme';
import { useWhatsAppMessageChannelFeature } from 'utils/hooks/featureFlags';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.base};
`;

const TextWrapper = styled.div`
  text-wrap: wrap;
`;

export type SenderIssueBannersProps = {
  sendLimit?: SendLimitDefinition;
  status?: WhatsAppSenderStatus;
};

export const SenderIssueBanners = ({ sendLimit, status }: SenderIssueBannersProps) => {
  const { isWhatsAppGAEnabled } = useWhatsAppMessageChannelFeature();
  const shouldShowRestrictedStatusBanner =
    !!status &&
    WHATSAPP_SENDER_RESTRICTED_STATUSES.includes(status) &&
    sendLimit &&
    sendLimit !== WhatsAppSendLimit.LimitNa;

  if (!isWhatsAppGAEnabled) return null;
  return (
    <Container>
      {shouldShowRestrictedStatusBanner && (
        <TextWrapper>
          <ErrorBanner
            data-test="whatsapp-restricted-status-banner"
            title="Sending limit reached:"
            isInlineTitle
          >
            This sender is temporarily restricted because it has reached its sending limit (
            {WHATSAPP_SEND_LIMIT_DISPLAY_MAPPING[sendLimit]?.friendlyNumber} new conversations) in
            the last 24 hours. You can still reply to ongoing conversations. The ability to start
            new conversations will gradually restore over the next 24 hours.
          </ErrorBanner>
        </TextWrapper>
      )}
      {status === WhatsAppSenderStatus.Flagged && (
        <TextWrapper>
          <WarningBanner data-test="whatsapp-flagged-status-banner" title="Flagged:" isInlineTitle>
            This sender is flagged by Meta due to low quality, preventing send limit upgrades. If
            quality doesn't improve within 7 days, the limit will drop to the next lower tier.
          </WarningBanner>
        </TextWrapper>
      )}
    </Container>
  );
};
